import React from "react";
import PropTypes from "prop-types";
import Button from "../../common/Button";
import SelectInput from "../../common/SelectInput";

const CopyDuurzaamheidButton = (props) => {
    const {
        selectedInfrastructuur,
        moreThenOneOtherInfrastructuur,
        otherInfrastructuren,
        disabled,
        onClickCopyDuurzaamheid,
        onChangeSelectedInfrastructuur,
        alignRight
    } = props;

    let copyFromOtherInfrastructuurButton = null;
    let buttonNode = null;

    if (!moreThenOneOtherInfrastructuur) {
        let buttonStyle = {};
        if (alignRight) {
            buttonStyle.float = "right";
        }
        copyFromOtherInfrastructuurButton = <Button onClick={onClickCopyDuurzaamheid} disabled={disabled} text={"Kopieer duurzaamheid van " + (selectedInfrastructuur ? selectedInfrastructuur.display : "")} small style={buttonStyle} />;
    } else {
        const infrastructurenForDropdown = otherInfrastructuren.map(item => { return { label: item.display, value: item.id }; });
        const selectInput =
            (<SelectInput
                name="infrastructuurToCopyId"
                onChange={onChangeSelectedInfrastructuur}
                value={selectedInfrastructuur ? selectedInfrastructuur.id : ""}
                disabled={disabled}
                items={infrastructurenForDropdown}
                small />);

        let wrapperStyle = { textAlign: "right" };
        if (alignRight) {
            wrapperStyle.float = "right";
        }

        copyFromOtherInfrastructuurButton = (<div style={wrapperStyle} className="c-input c-input-regular">
            <span>Kopieer duurzaamheid van</span>
            {selectInput}
            <Button onClick={onClickCopyDuurzaamheid} disabled={disabled} text={"Kopieer"} small />
        </div>);
    }
    buttonNode = copyFromOtherInfrastructuurButton;

    return buttonNode;
};

CopyDuurzaamheidButton.propTypes = {
    moreThenOneOtherInfrastructuur: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    otherInfrastructuren: PropTypes.array.isRequired,
    onClickCopyDuurzaamheid: PropTypes.func.isRequired,
    onChangeSelectedInfrastructuur: PropTypes.func.isRequired,
    alignRight: PropTypes.bool,
    selectedInfrastructuur: PropTypes.object
};

export default CopyDuurzaamheidButton;

